declare global {
   interface Window {
      _hsq?: Array<unknown[]>
   }
}

export function identifyHubspotContact(email: string | undefined) {
   if (!email || !window._hsq) return
   window._hsq.push(['identify', { email }])
   window._hsq.push(['trackPageView'])
}
